import { render, staticRenderFns } from "./StackEdit.vue?vue&type=template&id=12b7a4ae&scoped=true"
import script from "./StackEdit.vue?vue&type=script&lang=js"
export * from "./StackEdit.vue?vue&type=script&lang=js"
import style0 from "./StackEdit.vue?vue&type=style&index=0&id=12b7a4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7a4ae",
  null
  
)

export default component.exports